import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { PublicSectionModule } from './public/public.section.module';
import { PrivateSectionModule } from './private/private.section.module';
import { InfrastructureModule } from './infrastructure/infrastructure.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AddWithCredentialsInterceptorService } from './infrastructure/model/interfaces/AddWithCredentialsInterceptor.interface';
import { I18NextModule, I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import Backend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SxTranslationService } from './infrastructure/services/translation-service.service';

const resourcesToBackend = (res) => ({
  type: 'backend',
  init(services, backendOptions, i18nextOptions) { /* use services and options */ },
  read(language, namespace, callback) {
    res(language, namespace, callback)
  }
})

export function appInit(i18next: ITranslationService, sxTranslationService: SxTranslationService) {
  return async () => {
    let versions = await sxTranslationService.getVersions();

    return await i18next
      .use(Backend)
      .use(LanguageDetector)
      .init({
        fallbackLng: 'en',
        //debug: true,
        returnEmptyString: false,
        partialBundledLanguages: true,
        backend: {
          backends: [
            LocalStorageBackend,
            resourcesToBackend((language, namespace, callback) => {
              sxTranslationService.getAllSystemByLocale(language)
                .then(resLang => {
                  callback(null, resLang)
                })
                .catch((error) => {
                  callback(error, null)
                });
            })
          ],
          backendOptions: [{
            versions: versions
          },
          {}]
        },
        detection: {
          order: ['localStorage', 'navigator'],
          lookupLocalStorage: 'i18nextLng',
          caches: ['localStorage']
        }
      });
  }
}

export function localeIdFactory(i18next: ITranslationService) {
  return i18next.language;
}

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE, SxTranslationService],
    multi: true
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory
  }];


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    InfrastructureModule,
    PublicSectionModule,
    PrivateSectionModule,
    I18NextModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AddWithCredentialsInterceptorService, multi: true }, 
    I18N_PROVIDERS]
})

export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/app.module.ts